import { DEPARTMENT_TITLES, type DetailRow, type PaneData } from '../../shared/contracts';
import { MetricCard } from './MetricCard';
import { ListCard } from './ListCard';
import { ProgressCard } from './ProgressCard';
import { AgendaCard } from './AgendaCard';
import { BoardCard } from './BoardCard';
import { PaneFrame } from './PaneFrame';

interface PaneProps {
  pane: PaneData;
  wide?: boolean;
  onDrill?: (bucket?: string) => void;
  onOpslag?: (row: DetailRow) => void;
  showEyebrow?: boolean;
}

export function Pane({ pane, wide, onDrill, onOpslag, showEyebrow = true }: PaneProps) {
  const eyebrow = showEyebrow ? DEPARTMENT_TITLES[pane.department] : undefined;
  // error/empty panes carry no body — render the localized state centrally so it works for
  // EVERY kind, including metric/progress cards that would otherwise early-return null.
  if (pane.source.mode === 'error' || pane.source.mode === 'empty') {
    return <PaneFrame title={pane.title} source={pane.source} eyebrow={eyebrow} periodLabel={pane.periodLabel} />;
  }
  switch (pane.kind) {
    case 'metric':
      return <MetricCard pane={pane} wide={wide} onDrill={onDrill} eyebrow={eyebrow} />;
    case 'progress':
      return <ProgressCard pane={pane} eyebrow={eyebrow} onDrill={onDrill} />;
    case 'agenda':
      // The notice board gets its own post-it look; personal agendas stay a timeline.
      return pane.id === 'admin.board' ? (
        <BoardCard pane={pane} onOpslag={onOpslag} eyebrow={eyebrow} />
      ) : (
        <AgendaCard pane={pane} onOpslag={onOpslag} eyebrow={eyebrow} />
      );
    case 'list':
    case 'ranking':
      return <ListCard pane={pane} eyebrow={eyebrow} onDrill={onDrill} />;
    default:
      return null;
  }
}
